module.exports = __webpack_public_path__ + "static/Australia-abdae746111b8152b06f13efdbeeac06.jpg";